import { Link } from 'react-router-dom';

/**
 * Shared card shell used by every dashboard tile. Handles title, optional
 * action link in the top-right corner, and a few standard states
 * (loading/empty/error) so tiles can delegate.
 *
 * Children are the tile body — fetched data, etc.
 */
export default function TileCard({
  title,
  actionLabel,
  actionHref,
  loading,
  error,
  empty,
  emptyLabel = 'No data',
  children,
}) {
  return (
    <div className="dash-card">
      <div className="dash-card-header">
        <h3 className="dash-card-title">{title}</h3>
        {actionHref && (
          <Link to={actionHref} className="dash-card-action">
            {actionLabel || 'View all →'}
          </Link>
        )}
      </div>
      <div className="dash-card-body">
        {loading ? (
          <div className="dash-card-loading">Loading…</div>
        ) : error ? (
          <div className="dash-card-error">Couldn't load — {error}</div>
        ) : empty ? (
          <div className="dash-card-empty">{emptyLabel}</div>
        ) : (
          children
        )}
      </div>
    </div>
  );
}
